
export default class Func {

    static getInitials = (name) => {
        const hasTokens = name.indexOf(' ') !== -1
        return name.substring(0, hasTokens ? 1 : 2) + (hasTokens ? name.charAt(name.lastIndexOf(' ') + 1) : '')
    }
    static customRound = (number) => {
        return (number % 1 >= 0.5 ? Math.ceil(number) : Math.floor(number) + 1);

    }
    static verifyEmail = (value, t) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        let setMsgErrorEmail;
        if (!emailRegex.test(value)) {
            if (!value) {
                 setMsgErrorEmail = t("Please enter") + ' ' + t('Email'); // Set your error message
            } else {
                 setMsgErrorEmail = t("Invalid email format"); // Set your error message
            }
        }
        return setMsgErrorEmail

    }
}
